// extracted by mini-css-extract-plugin
export default {"one":"SecOne_one__WT-tR","main":"SecOne_main__4P9xp","gif":"SecOne_gif__9jKhD"};